import { render, staticRenderFns } from "./aprflow.vue?vue&type=template&id=643423b0&scoped=true&lang=pug&"
import script from "./aprflow.vue?vue&type=script&lang=js&"
export * from "./aprflow.vue?vue&type=script&lang=js&"
import style0 from "./aprflow.vue?vue&type=style&index=0&id=643423b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643423b0",
  null
  
)

export default component.exports